import React, { Component } from 'react'
import { graphql, Query } from 'react-apollo'
import compose from 'lodash/flowRight'
// eslint-disable-next-line
import { withRouter } from 'react-router-dom'
import {
  TextField,
  MenuItem
} from '@material-ui/core'
import { Form,
  //  Dropdown,
  Button,
  message,
  Input,
  DatePicker,
  Select,
  Tag,
  //  Tabs,
  Radio,
  Icon,
  Row,
  Col,
  Layout,
  Tooltip,
  Checkbox
} from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVenusMars } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment-timezone'
// const FormItem = Form.Item
import { withTranslation } from 'react-i18next'

import _get from 'lodash/get'
import _set from 'lodash/set'
import _groupBy from 'lodash/groupBy'
import _sortBy from 'lodash/sortBy'
import _isString from 'lodash/isString'
import _isEmpty from 'lodash/isEmpty'
import leftPad from 'left-pad'
import getAgeCategory from '~/utils/getAgeCategory'
// import getRaceDayAge from '~/utils/getRaceDayAge'
import _includes from 'lodash/includes'
import clientAuth from '../utils/client-auth'
import renderQuestionInput from '../utils/renderQuestionInput'
// import ImageUploader from './ImageUploader'
import CloudUploader from './CloudUploader'
import countries from '~/data/countries.json'
import nationalities from '~/data/nationalities.json'
import provinces from '~/data/provinces.json'
import participantQuery from '~/graphql/queries/participant.js'
import updateParticipantMutation from '~/graphql/mutations/updateParticipant.gql'
import Loading from '~/components/Loading'
import PartisipantNotFound from '~/components/Error/Partisipantnotfound'
import compare from '~/utils/compare'
import localeGet from '~/utils/localeGet'
import adminQuery from '~/graphql/queries/adminUser.gql'
import statesQuery from '~/graphql/queries/states.gql'
import config from '~/config'

const locale = config.default_locale || 'th'
class Ticket extends Component {
  submitting = false
  state = {
    confirmDirty: false,
    ticketGroupValidation: false
  }
  handleChangeTicketGroupIds = ({groupIndex, groupId}) => {
    // const { form: { resetFields, setFieldsValue, getFieldValue } } = this.props
    // const checked = e.target.checked
    // const id = e.target.id
    // this.props.form.validateFields((err, values) => {
    //   const ticket = _get(values, ['tickets', groupIndex])
    //   setFieldsValue({
    //     [`tickets[${groupIndex}]`]: null
    //   })
    //   if (!err) {
    //   }
    // })
  }
  render () {
    const { loading, admin, t } = this.props
    const {roles} = clientAuth.login()
    const Option = Select.Option
    const participant = _get(this.props.data, 'participant')
    const initProfile = _get(participant, 'profile')
    // let isLineLogin = _get(participant, 'event.isLineLogin')
    let isLineLogin = false
    if(_get(participant, 'profile.email') && _get(participant, 'profile.email').search('raceline+') > -1 && _get(participant, 'profile.email').search('@thai.run') > -1) {
      isLineLogin = true
    }
    const editDisabled = ['60e3fdaa1c327b52f5846959', '62d50043ec8d4b20cdcf9abf','62de4967bde39e9bf5acf796','62df9065293bc1688d374b22','62dfa7c1293bc1688d71b1e9','62e0fb45a6a9844612f7f3e5','62e1693ba6a984461203411d','62e21a5ea6a9844612a73d74','62e21e6ba6a9844612ac377e','62e21e77a6a9844612ac3ed7','62e21e9fa6a9844612aca19a','62e223fda6a9844612b41f6b','62e224b4a6a9844612b51097','62e22870a6a9844612bc4503','62e22dc1a6a9844612c2d793','62e2325fa6a9844612c8be2a','62e23c60a6a9844612d5d9d5','62e23f1ea6a9844612d93a7e','62e24299a6a9844612de3639','62e250c4a6a9844612f10219','62e25472a6a9844612f64c6e','62e74a94a6a9844612d538a6','62e78517a6a984461261371d','62e8be8876aa3cb36ac39baa','62e923f576aa3cb36a0c280f','62e95ecd76aa3cb36aac8792','62e9b89676aa3cb36ad3807a','62e9d25876aa3cb36a031fdd','62e9d78076aa3cb36a104e1a','62ea204b76aa3cb36adb12af','62ea912a76aa3cb36a20a9cf','62eaaadc76aa3cb36a64b6cf','62eb16a576aa3cb36abb0086','62eb7f4f76aa3cb36a5dbfe4','62eb8f1f76aa3cb36a99f7a5','62eb98a976aa3cb36abb2c35','62eb9cb076aa3cb36ad25639','62eba24676aa3cb36af12786','62ebbb7976aa3cb36a8735bc','62ec64a076aa3cb36a9d929b','62ecc0d676aa3cb36a85e2fb','62eccd5276aa3cb36ac75d83','62ecd70f76aa3cb36aff34c1','62ece26676aa3cb36a4497a0','62ece7df76aa3cb36a61fc2c','62ef2a0376aa3cb36a86c811','62ef3dd576aa3cb36aed26c4','62efcea676aa3cb36a899100','62f1205076aa3cb36a506f9c','62f255291090e021d1e2637f','62f27fb21090e021d17e215c','62f3104d1090e021d1519cd7','62f322b31090e021d1aaeb4c','62f3276e1090e021d1c032fe','62f33bc21090e021d1f5dd47','62f372b31090e021d1f129c9','62f39afa1090e021d134aa4e','62f3b1261090e021d1750fff','62f3bd501090e021d1b077a3','62f3c95c1090e021d1ecc936','62f3cdb91090e021d1055bc7','62f3d1a31090e021d11aa078','62f3d7a91090e021d135771a','62f3e7a51090e021d175b920','62f447e61090e021d188260d','62f4a0251090e021d135f394','62f513041090e021d16416ca','62f51cb41090e021d196e3bc','62f5ade01090e021d1bd641f','62f5b6a81090e021d1ed1ac4','62f62f9c1090e021d1032165','62f646261090e021d168dc96','62f688e91090e021d18ec09d','62f693261090e021d1b51f46','62f703ea1090e021d13dcd01','62f7c5f31090e021d17257fc','62f83d811090e021d1ec2530','62f895d71090e021d1646bbe','62f89e8d1090e021d18a3b60']
      .includes(`${_get(participant, 'eventId')}`)
    if(editDisabled) {
      return <>
        <h1 style={{textAlign: 'center', marginTop: '30px'}}>
          ปิดการแก้ไขข้อมูล
        </h1>
      </>
    }
    const inputCols = {
      // labelCol: { span: 4 },
      // wrapperCol: { span: 20 }
    }

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      }
    }

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0
        },
        sm: {
          span: 14,
          offset: 6
        }
      }
    }
    const requiredFieldMessage = 'This field is required'
    const getRules = (field) => {
      const rules = []
      if (!field) {
        return rules
      }
      if (field.required) {
        rules.push({
          required: true,
          message: requiredFieldMessage
        })
      }
      if (field.name === 'nationalId') {
        return rules
      }
      if (field.validations) {
        field.validations.forEach(validation => {
          switch (validation.type) {
            case 'pattern': return rules.push({
              pattern: new RegExp(validation.params[0]),
              message: localeGet(validation, 'message', `${config.default_locale}`)
            })
            default:
          }
        })
      }
      return rules
    }
    if (loading) {
      return <Loading />
    } else if (!participant) {
      return <PartisipantNotFound />
    } else {
      const ticketTypeLocked = !(_includes(roles, 'admin') || _includes(admin.abilities, 'ticketType'))
      const dateFormat = 'DD/MM/YYYY'
      const { getFieldValue, resetFields, getFieldDecorator, setFieldsValue } = this.props.form
      const event = _get(participant, 'event')
      const eventTicketGroups = _get(event, 'ticketGroups')
      const registration = _get(participant, 'registration')
      const { registrationType } = registration

      // const ticketTypeIds = _get(registration, 'registrationType.ticketTypeIds', [])
      const ticketTypeAgeFilter = (ticketType) => {
        const ageCategoryIds = _get(ticketType, 'ageCategoryIds', [])
        if (ageCategoryIds.length > 0) {
          const ageCategory = getAgeCategory({ race: ticketType.race, birthDate, gender })
          const catId = _get(ageCategory, 'category._id')
          return ageCategoryIds.includes(catId)
        }
        return true
      }
      let participantFields = _get(event, 'settings.participant.fields', []) || []
      let regFields = participantFields
        .filter(f => f.enabled)
        .reduce((result, field) => {
          result[field.name] = field
          return result
        }, {})

      const ticketTypes = _get(event, 'ticketTypes', []) // no need to filter registration type tickets .filter(tt => ticketTypeIds.includes(tt._id))
      const tickets = _get(participant, 'tickets', [])

      const shirtTypeMessage = _get(event, 'shirtTypeMessage')
      const shirtTypes = _get(event, 'shirtTypes', [])
      const finisherShirtTypeMessage = _get(event, 'finisherShirtTypeMessages', [])
      const finisherShirtTypes = _get(event, 'finisherShirtTypes', []) || []
      const finisherShirts = _get(event, 'finisherShirts', []) || []
      const shirtCounts = _get(event, 'shirtCounts', [])

      // let participantFields = []
      const handleSubmit = e => {
        // const savedMsg = () => {
        //   message.success('Saved')
        // }
        // const savedMsgErr = () => {
        //   message.error('Error!')
        // }
        e.preventDefault()
        this.props.form.validateFieldsAndScroll((err, tempRecord) => {
          if (!err) {
            let participant = tempRecord
            const ticketGroups = _groupBy(ticketTypes, 'groupId')
            const ticketGroupIds = Object.keys(ticketGroups)
            if (
              _get(ticketGroupIds, [0]) !== 'null' &&
              _get(ticketGroupIds, 'length') > 0 &&
              Object.values(
                _get(tempRecord, 'ticketGroup.id')
              ).filter(r => r[0] !== undefined).length === 0
            ) {
              this.setState({ ticketGroupValidation: true })
              return
            }
            if (_get(participant, 'ticketGroup')) {
              delete participant.ticketGroup
            }
            participant.tickets = participant.tickets.filter(ticket => {
              return _get(ticket, 'productTypeId')
            })
            if (_isString(participant.profileImageFile)) {
              participant.profileImageFile = {
                mimeType: null,
                base64data: null
              }
            }
            const birthDate = _get(participant, 'profile.birthDate', moment()).toISOString()
            _set(participant, 'profile.birthDate', birthDate)
            this.submitting = true
            this.props.updateParticipant({
              variables: {
                _id: _get(this.props, 'data.participant._id'),
                record: participant
              }
            }).then(result => {
              message.success('Saved!')
              this.props.history.push(`/events/${_get(this.props, 'data.participant.event._id')}/participants/${_get(participant, '_id')}`)
            }).catch(err => message.error(err.message))
              .finally(() => { this.submitting = false })
            // savedMsg()
            // this.props.history.push(`/events/${this.props.data.participant.event._id}/tickets/${values.tickets._id}`)
          } else {
            message.error(err)
          }
        })
      }
      getFieldDecorator('_id', {
        initialValue: participant._id
      })
      getFieldDecorator('userId', {
        initialValue: participant.userId
      })
      getFieldDecorator('eventId', {
        initialValue: participant.eventId
      })
      getFieldDecorator('registrationId', {
        initialValue: participant.registrationId
      })
      getFieldDecorator('order', {
        initialValue: participant.order
      })
      getFieldDecorator('createdByUserId', {
        initialValue: participant.createdByUserId
      })

      // function toNameMonth (num) {
      //   return moment(num + '', 'MM').format('MMMM')
      // }
      // getFieldDecorator(`__index`, {
      //   initialValue: index
      // })
      // setFieldsValue({
      //   [`__index`]: index
      // })
      // const $participantPanes = participant.map((participant, index) => {
      // const inputCols = {
      //   labelCol: { span: 4 },
      //   wrapperCol: { span: 20 }
      // }
      const ticketTypeNationalityFilter = (ticketType) => {
        if (!ticketType.nationalities) {
          return true
        }
        if (ticketType.nationalities.length === 0) {
          return true
        }
        return ticketType.nationalities.includes(nationality)
      }
      const ticketGroups = _groupBy(ticketTypes, 'groupId')
      const ticketGroupIds = Object.keys(ticketGroups)
      let selectedTicketGroupIds = []
      const $ticketGroups = ticketGroupIds.map((groupId, groupIndex) => {
        const ticket = tickets.find(ticket => [null, groupId].includes(_get(ticket, 'ticketType.groupId')))
        let selectedTicketGroupId = getFieldValue(`ticketGroup.id[${groupId}]`) || [_get(ticket, 'ticketType.groupId')]
        selectedTicketGroupIds = [...selectedTicketGroupIds, ...selectedTicketGroupId]
        getFieldDecorator(`tickets[${groupIndex}]._id`, {
          initialValue: _get(ticket, '_id')
        })
        const ticketGroup = eventTicketGroups.find(g => g._id === groupId)
        const ticketGroup$ = groupId !== 'null' && <Form.Item
          className='ticketGroupForm'
          {...inputCols}
        >
          {getFieldDecorator(`ticketGroup.id[${groupId}]`, {
            initialValue: selectedTicketGroupId
          })(
            <Checkbox.Group >
              <Checkbox key={groupId} value={groupId}
                disabled={ticketTypeLocked}
                onChange={() => this.handleChangeTicketGroupIds({groupIndex, groupId})}
                className='bigTitle'>
                <span className='checkboxLabel'>{localeGet(ticketGroup, 'name', locale)}</span>
              </Checkbox>
            </Checkbox.Group>
          )
          }
        </Form.Item>
        let afterTicketGroup$ = <div/>
        if (selectedTicketGroupId[0] || groupId === 'null') {
        // const ticketTypeDecorator = getFieldDecorator(`tickets[${groupIndex}].productTypeId`, { exclusive: true })
          const ticketTypeId = getFieldValue(`tickets[${groupIndex}].productTypeId`) || _get(ticket, 'productTypeId')
          let availableTicketTypes = _sortBy(ticketGroups[groupId], ['order'])
            .filter(ticketTypeAgeFilter)
            .filter(ticketTypeNationalityFilter)
          let eventTicketGroup
          if (groupId && _get(eventTicketGroups, 'length') > 0) {
            eventTicketGroup = eventTicketGroups.find(g => g._id === groupId)
            if (_get(eventTicketGroup, 'hidden')) {
              availableTicketTypes = availableTicketTypes.map(t => {
                return {
                  ...t,
                  name: {
                    en: 'Closed',
                    zh: 'Closed',
                    th: 'ปิดรับสมัคร'
                  }
                }
              })
            }
          }
          let selectedTicketType = availableTicketTypes.find(
            ticketType => ticketType._id === ticketTypeId
          ) || availableTicketTypes[0]
          // TODO: should be immutable
          participantFields = participantFields.concat(_get(selectedTicketType, 'participantFields', []) || [])
          regFields = participantFields
            .filter(f => f.enabled)
            .reduce((result, field) => {
              result[field.name] = field
              return result
            }, {})
          // const questions = _sortBy(
          //   _get(event, 'ticketQuestions', []).concat(
          //     _get(selectedTicketType, 'questions', [])
          //   ),
          //   ['order']
          // )
          const questions = _sortBy(
            _get(selectedTicketType, 'questions', []),
            ['order']
          )
          const shirtEnabled = _get(selectedTicketType, 'shirtEnabled', false)
          const finisherShirtEnabled = _get(selectedTicketType, 'finisherShirtEnabled', false)

          const ticketTypeIdCount = _get(event, 'ticketTypeCount')
          // const ticketTypeCount = ticketTypeIdCount.map(({ _id }) => )
          // const resetTicketType = () => {
          //   resetFields([`tickets[${groupIndex}].ticketTypeId`])
          // }
          const resetQuestions = (ticketTypeId) => {
          // const selectedTicketType = ticketTypes.find(
          //   ticketType => ticketType._id === ticketTypeId
          // )
          // const shirtEnabled = _get(selectedTicketType, 'shirtEnabled', false)
          // const finisherShirtEnabled = _get(selectedTicketType, 'finisherShirtEnabled', false)
            resetFields([
            // `tickets[${groupIndex}].couponCodeText`,
              `tickets[${groupIndex}].shirtTypeId`,
              `tickets[${groupIndex}].shirtId`,
              `tickets[${groupIndex}].__couponCodeInfo`,
              `tickets[${groupIndex}].reservedNumber`,
              ...questions.reduce((fields, q, questionIndex) => ([
                ...fields,

                `tickets[${groupIndex}].options[${questionIndex}].shirtTypeId`,
                `tickets[${groupIndex}].options[${questionIndex}].shirtId`,
                `tickets[${groupIndex}].options[${questionIndex}].questionId`,
                `tickets[${groupIndex}].options[${questionIndex}].value`,
                `tickets[${groupIndex}].options[${questionIndex}].Choice`,
                `tickets[${groupIndex}].options[${questionIndex}].MultiChoice`
              ]), [])
            // ...questions.map((question, questionIndex) => {
            //   const optionField = {
            //     Open: 'value',
            //     Choice: 'itemId',
            //     MultiChoice: 'itemIds'
            //   }[question.kind]
            //   return `tickets[${groupIndex}].options[${questionIndex}].${optionField}`
            // })
            ])
            setFieldsValue({
            // `tickets[${groupIndex}].couponCodeText`,
              [`tickets[${groupIndex}].shirtTypeId`]: null,
              [`tickets[${groupIndex}].shirtId`]: null,
              // [`tickets[${groupIndex}].options`]: null
              ...questions.reduce((fields, q, questionIndex) => ({
                ...fields,
                [`tickets[${groupIndex}].options[${questionIndex}].shirtTypeId`]: null,
                [`tickets[${groupIndex}].options[${questionIndex}].shirtId`]: null,
                // [`tickets[${groupIndex}].options[${questionIndex}].questionId`]: null,
                [`tickets[${groupIndex}].options[${questionIndex}].value`]: null,
                [`tickets[${groupIndex}].options[${questionIndex}].Choice`]: null,
                [`tickets[${groupIndex}].options[${questionIndex}].MultiChoice`]: null
              }), {})
            })
            // if (!shirtEnabled) {
            getFieldDecorator(`tickets[${groupIndex}].shirtTypeId`)
            getFieldDecorator(`tickets[${groupIndex}].shirtId`)
            setFieldsValue({
              [`tickets[${groupIndex}].shirtTypeId`]: null,
              [`tickets[${groupIndex}].shirtId`]: null
            })
            // }
            // if (finisherShirts.length > 0 && !finisherShirtEnabled) {
            getFieldDecorator(`tickets[${groupIndex}].finisherShirtTypeId`)
            getFieldDecorator(`tickets[${groupIndex}].finisherShirtId`)
            setFieldsValue({
              [`tickets[${groupIndex}].finisherShirtTypeId`]: null,
              [`tickets[${groupIndex}].finisherShirtId`]: null
            })
          }
          // }
          const $ticketQuestions = questions.map((question, questionIndex) => {
            const option = _get(ticket, 'options', []).find(o => o.questionId === question._id)

            getFieldDecorator(
              `tickets[${groupIndex}].options[${questionIndex}]._id`,
              {
                initialValue: _get(option, '_id')
              }
            )
            getFieldDecorator(
              `tickets[${groupIndex}].options[${questionIndex}].questionId`,
              {
                initialValue: question._id
              }
            )
            getFieldDecorator(
              `tickets[${groupIndex}].options[${questionIndex}].order`,
              {
                initialValue: question.order
              }
            )
            if (_get(question, 'inputType') === 'shirtTypes') {
              const condition = _get(question, 'condition')
              if (_get(condition, 'questionId')) {
                console.log('condition', _get(condition, 'questionId'), _get(condition, 'questionId'), {condition}, {question}, {questions})
                const condQuestionIndex = questions.findIndex(q => q._id === condition.questionId)
                const condQuestion = questions[condQuestionIndex]
                const condOptionField = {
                  Open: 'value',
                  Choice: 'itemId',
                  MultiChoice: 'itemIds'
                }[condQuestion.kind]
                const value = getFieldValue(`tickets[${groupIndex}].options[${condQuestionIndex}].${condOptionField}`)

                if (!compare(value, condition.operator, condition.value)) {
                  getFieldDecorator(`tickets[${groupIndex}].options[${questionIndex}].shirtTypeId`, { rules: [{ required: false }] })
                  getFieldDecorator(`tickets[${groupIndex}].options[${questionIndex}].shirtId`, { rules: [{ required: false }] })
                  return <div key={questionIndex} />
                }
              }
              const shirtTypeIds = _get(question, `shirtTypeIds`, []) || []
              const availableShirtTypes = shirtTypes.filter(type => shirtTypeIds.length === 0 || shirtTypeIds.includes(type._id))
              let shirtTypeId = _get(option, `shirtTypeId`)
              if (!shirtTypeId) {
                shirtTypeId = availableShirtTypes.length === 1 ? _get(availableShirtTypes, [0, '_id']) : getFieldValue(`tickets[${groupIndex}].options[${questionIndex}].shirtTypeId`)
              }
              shirtTypeId = getFieldValue(`tickets[${groupIndex}].options[${questionIndex}].shirtTypeId`) || shirtTypeId
              const shirtType = availableShirtTypes.find(type => type._id === shirtTypeId)
              const shirtIds = _get(question, `shirtIds`, []) || []
              return (<div key={`tickets[${groupIndex}].options[${questionIndex}]`}>
                <Form.Item
                  label={
                    <span>
                      {localeGet(question, 'name', locale)}
                      {question.infoMessage &&
                      <Tooltip title={localeGet(question, 'infoMessage', locale)} placement="rightBottom">
                        &nbsp;<Icon type="question-circle-o" style={{ fontSize: 'large' }} />
                      </Tooltip>
                      }
                    </span>
                  }
                  {...inputCols}
                  extra={localeGet(question, 'extraMessage', `${config.default_locale}`)}
                  key={questionIndex}
                >
                  {getFieldDecorator(
                    `tickets[${groupIndex}].options[${questionIndex}].shirtTypeId`,
                    {
                      initialValue: shirtTypeId,
                      rules: [{
                        required: true,
                        message: requiredFieldMessage
                      }]
                    }
                  )(<Radio.Group onChange={() => resetFields([`tickets[${groupIndex}].options[${questionIndex}].shirtId`]) || setFieldsValue({
                    [`tickets[${groupIndex}].options[${questionIndex}].shirtId`]: null
                  })} >
                    {availableShirtTypes.map(type =>
                      <Radio key={type._id} value={type._id} >
                        {localeGet(type, 'name', locale)}
                      </Radio>
                    )}
                  </Radio.Group>)}
                  {(shirtType && shirtType.imageUrl) &&
                  <div>
                    <img src={shirtType.imageUrl} alt="shirt type" style={{ maxWidth: '300px' }} />
                  </div>
                  }
                </Form.Item>
                {shirtTypeId && <Form.Item
                  label={'Shirt Size'}
                  {...inputCols}
                >
                  {getFieldDecorator(`tickets[${groupIndex}].options[${questionIndex}].shirtId`, {
                    initialValue: _get(option, 'shirtId'),
                    rules: [{
                      required: true,
                      message: requiredFieldMessage
                    }]
                  })(
                    <Select >
                      {shirtCounts.filter(s => s.shirtTypeId === shirtTypeId && (shirtIds.length === 0 || shirtIds.includes(s._id))).map(shirt => {
                        let full = shirt.quantity && shirt.count >= shirt.quantity
                        if (full === 0) full = false
                        return <Select.Option key={shirt._id} value={shirt._id} disabled={full}>
                          {localeGet(shirt, 'name', locale)}{' '}
                          {full && <Tag color="red">
                            {{ en: 'Full', zh: 'Full', th: 'หมด' }[locale]}
                          </Tag>}
                        </Select.Option>
                      })}
                    </Select>
                  )}
                </Form.Item>}
              </div>)
            } else {
              const optionField = {
                Open: 'value',
                Choice: 'itemId',
                MultiChoice: 'itemIds'
              }[question.kind]
              const optionValidator = (rule, value, callback) => {
              // TODO: separate to utils
                if (question.opts && question.opts.validator) {
                  const { validator } = question.opts
                  let valid = true
                  if (value) {
                    if (validator.itemCount) {
                      if (
                        validator.itemCount.min &&
                      value.length < validator.itemCount.min
                      ) {
                        valid = false
                      }
                      if (
                        validator.itemCount.max &&
                      value.length > validator.itemCount.max
                      ) {
                        valid = false
                      }
                      if (!valid) {
                        const message = `must be between ${validator.itemCount.min} and ${validator.itemCount.max} items`
                        return callback(message)
                      }
                    }
                    let messages = []
                    if (validator.min && value < validator.min) {
                      valid = false
                      messages.push(`must be greater than ${validator.min}`)
                    }
                    if (validator.max && value > validator.max) {
                      valid = false
                      messages.push(`must be less than ${validator.max}`)
                    }
                    if (!valid) {
                      const message = messages.join(' and ')
                      return callback(message)
                    }
                  } else {
                    valid = false
                  }
                }
                callback()
              }
              const questionRules = [{ validator: optionValidator }].concat(getRules(question))
              questionRules.push({ required: question.required, message: `${localeGet(question, 'name', locale)} is Required` })
              const optionDecorator = getFieldDecorator(
                `tickets[${groupIndex}].options[${questionIndex}].${optionField}`,
                {
                  initialValue: _get(option, `${optionField}`) || question.default,
                  rules: questionRules
                }
              )
              const optionValue = [].concat(getFieldValue(`tickets[${groupIndex}].options[${questionIndex}].${optionField}`))
              const selectedOption = question.items.find(i => optionValue.includes(i._id))
              const condition = _get(question, 'condition')
              if (_get(condition, 'questionId')) {
                const condQuestionIndex = questions.findIndex(q => q._id === condition.questionId)
                const condQuestion = questions[condQuestionIndex]
                const condOptionField = {
                  Open: 'value',
                  Choice: 'itemId',
                  MultiChoice: 'itemIds'
                }[_get(condQuestion, 'kind')]
                const value = getFieldValue(`tickets[${groupIndex}].options[${condQuestionIndex}].${condOptionField}`)

                if (!compare(value, condition.operator, condition.value)) {
                  getFieldDecorator(`tickets[${groupIndex}].options[${questionIndex}].${optionField}`, { rules: [{ required: false }] })
                  return <div key={questionIndex} />
                }
              }

              return (
                <Form.Item
                  label={
                    <span>
                      {localeGet(question, 'name', locale)}
                      {question.infoMessage &&
                      <Tooltip title={localeGet(question, 'infoMessage', locale)} placement="rightBottom">
                        &nbsp;<Icon type="question-circle-o" style={{ fontSize: 'large' }} />
                      </Tooltip>
                      }
                    </span>
                  }
                  {...inputCols}
                  extra={localeGet(question, 'extraMessage', `${config.default_locale}`)}
                  key={questionIndex}
                >
                  {optionDecorator(renderQuestionInput({ question, locale }))}
                  {selectedOption && selectedOption.imageUrl &&
                  <div>
                    <img src={selectedOption.imageUrl} alt={localeGet(selectedOption, 'value', locale)} style={{ maxWidth: '300px' }}/>
                  </div>
                  }
                </Form.Item>
              )
            }
          })
          //   TshirtTypeId: _get(ticket, 'shirtTypeId'),
          //   d: _get(shirtTypes, [0, '_id'])
          // })

          const shirtTypeIds = _get(selectedTicketType, 'shirtTypeIds', []) || []
          const availableShirtTypes = shirtTypes.filter(type => shirtTypeIds.length === 0 || shirtTypeIds.includes(type._id))
          const shirtTypeId = getFieldValue(`tickets[${groupIndex}].shirtTypeId`) || _get(ticket, 'shirtTypeId') || _get(availableShirtTypes, [0, '_id'])
          const shirtType = availableShirtTypes.find(type => type._id === shirtTypeId)

          const shirtTypeDecorator = getFieldDecorator(`tickets[${groupIndex}].shirtTypeId`, {
            initialValue: shirtEnabled ? _get(ticket, 'shirtTypeId') || shirtTypeId : null,
            rules: [{
              required: shirtEnabled,
              message: requiredFieldMessage
            }]
          })
          let $shirtTypes, $shirts
          if (availableShirtTypes.length > 0) {
            $shirtTypes = (
              <Form.Item
                label={'Shirt Type'}
                {...inputCols}
                extra={_get(shirtTypeMessage, locale)}
              >
                {shirtTypeDecorator(
                  <Radio.Group onChange={() => resetFields([`tickets[${groupIndex}].shirtId`]) || setFieldsValue({
                    [`tickets[${groupIndex}].shirtId`]: null
                  })} >
                    {availableShirtTypes.map(type =>
                      <Radio key={type._id} value={type._id} >
                        {localeGet(type, 'name', locale)}
                      </Radio>
                    )}
                  </Radio.Group>
                )}
                {(shirtType && shirtType.imageUrl) &&
                <div>
                  <img src={shirtType.imageUrl} alt="shirt type" style={{ maxWidth: '300px' }} />
                </div>
                }
              </Form.Item>
            )
            // shirtTypeId = getFieldValue(`tickets[${groupIndex}].shirtTypeId`)
            const shirtIds = _get(selectedTicketType, 'shirtIds', [])
            $shirts = (
              <Form.Item
                label="Shirt Size"
                {...inputCols}
              >
                {getFieldDecorator(`tickets[${groupIndex}].shirtId`, {
                  initialValue: shirtEnabled && _get(ticket, 'shirtTypeId') ? _get(ticket, 'shirtId') : null,
                  rules: [{
                    required: shirtEnabled,
                    message: requiredFieldMessage
                  }]
                })(
                  <Select >
                    {shirtCounts.filter(s => s.shirtTypeId === shirtTypeId && (shirtIds.length === 0 || shirtIds.includes(s._id))).map(shirt => {
                      let full = shirt.quantity && shirt.count >= shirt.quantity
                      if (full === 0) full = false
                      return <Select.Option key={shirt._id} value={shirt._id} disabled={full}>
                        {localeGet(shirt, 'name', locale)}{' '}
                        {full && <Tag color="red">
                          {{ en: 'Full', zh: 'Full', th: 'หมด' }[locale]}
                        </Tag>}
                      </Select.Option>
                    })}
                  </Select>
                )}
              </Form.Item>
            )
          }

          const finisherShirtTypeIds = _get(selectedTicketType, 'finisherShirtTypeIds', []) || []
          const availableFinisherShirtTypes = finisherShirtTypes.filter(type => finisherShirtTypeIds.length === 0 || finisherShirtTypeIds.includes(type._id))
          const initFinisherShirtTypeId = (_get(availableFinisherShirtTypes, 'length') === 1
            ? _get(availableFinisherShirtTypes, [0, '_id'])
            : null)
          const finisherShirtTypeId = getFieldValue(`tickets[${groupIndex}].finisherShirtTypeId`) ||
            _get(ticket, 'finisherShirtTypeId') || initFinisherShirtTypeId

          const finisherShirtTypeDecorator = getFieldDecorator(`tickets[${groupIndex}].finisherShirtTypeId`, {
            // initialValue: finisherShirtEnabled && finisherShirtTypes.length === 1 ? _get(ticket, 'finisherShirtTypeId') || _get(finisherShirtTypes, [0, '_id']) : null,
            initialValue: finisherShirtEnabled ? _get(ticket, 'finisherShirtTypeId') || finisherShirtTypeId : null,
            rules: [{
              required: finisherShirtEnabled && finisherShirtTypes.length > 0,
              message: requiredFieldMessage
            }]
          })
          const finisherShirtType = availableFinisherShirtTypes && availableFinisherShirtTypes.find(type => `${type._id}` === `${finisherShirtTypeId}`)
          let $finisherShirtTypes, $finisherShirts
          if (availableFinisherShirtTypes.length > 0) {
            $finisherShirtTypes = (
              <Form.Item
                label="Finisher Shirt Type"
                {...inputCols}
                extra={_get(finisherShirtTypeMessage, locale)}
              >
                {finisherShirtTypeDecorator(
                  <Radio.Group onChange={() => resetFields([`tickets[${groupIndex}].finisherShirtId`]) || setFieldsValue({
                    [`tickets[${groupIndex}].finisherShirtId`]: null
                  })} >
                    {availableFinisherShirtTypes.map(type =>
                      <Radio key={type._id} value={type._id} >
                        {localeGet(type, 'name', locale)}
                      </Radio>
                    )}
                  </Radio.Group>
                )}
                {(finisherShirtType && finisherShirtType.imageUrl) &&
                  <div>
                    <img src={finisherShirtType.imageUrl} alt="shirt type" style={{ maxWidth: '300px' }} />
                  </div>
                }
              </Form.Item>
            )
            // finisherShirtTypeId = getFieldValue(`tickets[${groupIndex}].finisherShirtTypeId`)
            // const finisherShirtIds = _get(selectedTicketType, 'finisherShirtIds', [])
            $finisherShirts = (
              <Form.Item
                label="Finisher Shirt Size"
                {...inputCols}
              >
                {getFieldDecorator(`tickets[${groupIndex}].finisherShirtId`, {
                  initialValue: finisherShirtEnabled ? _get(ticket, 'finisherShirtId') : null,
                  rules: [{
                    required: finisherShirtEnabled,
                    message: requiredFieldMessage
                  }]
                })(
                  <Select>
                    {finisherShirts.filter(s => s.shirtTypeId === finisherShirtTypeId).map(shirt =>
                      <Select.Option key={shirt._id} value={shirt._id} disabled={shirt.quantity && shirt.count >= shirt.quantity}>
                        {localeGet(shirt, 'name', locale)}
                      </Select.Option>
                    )}
                  </Select>
                )}
              </Form.Item>
            )
          }
          const couponCodeText = getFieldValue(
            `tickets[${groupIndex}].couponCodeText`
          )
          getFieldDecorator(`tickets[${groupIndex}].couponCodeId`)
          getFieldDecorator(`tickets[${groupIndex}].__couponCodeInfo`)
          const couponCodeInfo = getFieldValue(
            `tickets[${groupIndex}].__couponCodeInfo`
          )
          // [`tickets[${groupIndex}].options`]
          // const couponCodeInfo = couponCodeText
          const couponCodeEnabled = _get(event, 'settings.couponCode.enabled')
          const deliveryOption = _get(selectedTicketType, 'deliveryOption', 'none') || 'none'
          const noDelivery = deliveryOption === 'none'
          const deliveryRequired = deliveryOption === 'required'
          const deliveryDecorator = getFieldDecorator(`tickets[${groupIndex}].delivery`, {
          // valuePropName: 'checked',
            initialValue: deliveryRequired || _get(
              participant,
              `tickets[${groupIndex}].delivery`
            ),
            rules: [{ required: !noDelivery }] // [{ required: true }] // [{ required: deliveryRequired }]
          })
          const deliverySelected = getFieldValue(`tickets[${groupIndex}].delivery`)
          const reservedNumbers = _isEmpty(_get(selectedTicketType, 'reservedNumbers', [])) ? _get(event, 'settings.ticket.reservedNumbers', []) : selectedTicketType.reservedNumbers
          const reservedNumbersTaken = _get(event, 'reservedNumbersTaken', [])
          // const ticketsQuota = _get(event, 'ticketsQuota', [])
          // const ticketLimitReached = ticketsQuota.reduce((result, rec) => {
          //   result[rec._id] = rec.limit > 0 && rec.count >= rec.limit
          //   return result
          // }, {})
          // const ticketTypeLocked = ['paid', 'submitted', 'accepted', 'rejected'].includes(registration.status)
          const ticketTypeDecorator = getFieldDecorator(
            `tickets[${groupIndex}].productTypeId`,
            {
            // initialValue: _get(selectedTicketType, '_id'),
              initialValue: availableTicketTypes.length === 1 ? _get(selectedTicketType, '_id') : _get(ticket, 'productTypeId'),
              rules: [{ required: true, message: 'Please select ticket type' }]
            }
          )
          afterTicketGroup$ = (_get(selectedTicketGroupId, [0]) || groupId === 'null') && <Input.Group key={`group_${groupId}`} className="afterTicketGroup" >
            <Form.Item
              // label={groupId !== 'null' ? localeGet(eventTicketGroup, 'name', locale) : { en: 'Race', zh: 'Race', th: 'ประเภทการแข่งขัน' }[locale]}
              label={`${t('participant.race')}`}
              extra={selectedTicketType &&
              <React.Fragment>
                {/* {selectedTicketType.race.ageCategories &&
                <FormattedMessage id="app.ageCategoryMessage" values={{
                  category: this.ageCategoryString(
                    getAgeCategory({
                      race: selectedTicketType.race,
                      birthDate,
                      gender
                    })
                  )}} />
                } */}
                {selectedTicketType.extraMessage && <div>
                  {localeGet(selectedTicketType, 'extraMessage', `${config.default_locale}`)}
                </div>
                }
              </React.Fragment>
              }
              {...inputCols}
            >
              {/* ticketTypeDecorator(
                    <Radio.Group key={group} onChange={() => resetQuestions()}>
                      {ticketGroups[group].map(ticketType => (
                        <Radio.Button key={ticketType._id} value={ticketType._id}>
                          {localeGet(ticketType, 'name', locale)}
                        </Radio.Button>
                      ))}
                    </Radio.Group>,
                  ) */}
              {ticketTypeDecorator(<Select key={groupId} onChange={resetQuestions} defaultActiveFirstOption disabled={ticketTypeLocked}>
                {availableTicketTypes.map(ticketType => {
                  const ticketTypeFull = ticketType.quantity > 0 && _get(ticketTypeIdCount.find(c => c._id === ticketType._id), 'count', 0) >= ticketType.quantity
                  // const limitReached = ticketType.limitId && ticketLimitReached[ticketType.limitId]
                  const full = ticketTypeFull
                  // const full = ticketTypeFull || limitReached
                  // const full = ticketType.quantity > 0 && _get(ticketTypeIdCount.find(c => c._id === ticketType._id), 'count', 0) >= ticketType.quantity
                  return <Select.Option
                    key={ticketType._id}
                    value={ticketType._id}
                    disabled={full}
                  >
                    {(!registrationType.hideTicketTypePrice && ticketType.price !== null) && <Tag color="blue">{ticketType.price} THB</Tag>}
                    {full && <Tag color="red">
                      {{ en: 'Full', zh: 'Full', th: 'เต็ม' }[locale]}
                    </Tag>}
                    {localeGet(ticketType, 'name', locale)}
                  </Select.Option>
                }
                )}
              </Select>)}
              {selectedTicketType &&
              <div style={{ whiteSpace: 'pre-line' }}>
                {localeGet(selectedTicketType, 'customMessage', locale)}
                {selectedTicketType.imageUrl &&
                  <div>
                    <img src={selectedTicketType.imageUrl} alt="ticket type" style={{ maxWidth: '300px' }} />
                  </div>
                }
              </div>
              }
            </Form.Item>
            {/* {!isNoneSelectedTicketType && <div> */}
            {<div>
              {selectedTicketType && selectedTicketType.reserveNumber && <Form.Item label={{ en: 'BIB Number', zh: 'BIB Number', th: 'เบอร์วิ่ง' }[locale]} {...inputCols}>
                {getFieldDecorator(`tickets[${groupIndex}].reservedNumber`, {
                  initialValue: `${_get(participant, `tickets[${groupIndex}].reservedNumber`, '')}`, // TODO: only !editMode
                  rules: [
                    {
                      pattern: /^\d+$/,
                      message: 'Please enter digits only'
                    },
                    {
                      validator: this.reservedNumberValidator
                    },
                    {
                      required: true,
                      message: requiredFieldMessage
                    }
                  ]
                })(<Select
                  showSearch
                  filterOption={(input, option) => option.props.value.indexOf(input) >= 0}
                >
                  {reservedNumbers.map(number =>
                    <Select.Option value={leftPad(`${number}`, 4, '0')} key={number} disabled={reservedNumbersTaken.includes(number)}>
                      {leftPad(`${number}`, 4, '0')}
                    </Select.Option>
                  )}
                </Select>)}
              </Form.Item>}
              {regFields['nameOnBib'] && <Form.Item label={`${t('participant.nameonbib')}`} {...inputCols}
                extra={localeGet(regFields, 'nameOnBib.extraMessage', `${config.default_locale}`)}>
                {getFieldDecorator(`tickets[${groupIndex}].nameOnBib`, {
                  initialValue: _get(
                    participant,
                    `tickets[${groupIndex}].nameOnBib`
                  ) || _get(initProfile, 'nameOnBib') || "",
                  // normalize: (value) => (value ? value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase() : ''),
                  rules: getRules(regFields['nameOnBib'])
                })(<Input />)}
              </Form.Item>}
              {shirtTypes.length > 0 && shirtEnabled && $shirtTypes}
              {shirtTypeId && shirtEnabled && $shirts}
              {finisherShirtTypes.length > 0 && finisherShirtEnabled && $finisherShirtTypes}
              {finisherShirtTypeId && finisherShirtEnabled && $finisherShirts}
              {selectedTicketType && !noDelivery &&
            <Form.Item className="modRadioFormItem" key="delivery" label={{ en: 'Race Pack Collection', zh: 'Race Pack Collection', th: selectedTicketType.deliveryPrice > 0 ? 'รับเสื้อ' : 'รับเสื้อ' }[locale]} {...inputCols}>
              {deliveryDecorator(
                <Radio.Group>
                  <Radio value={true}>
                    <Tag color="blue">+{selectedTicketType.deliveryPrice} THB</Tag>{{ en: 'Post Delivery', zh: 'Post Delivery', th: `ทางไปรษณีย์` }[locale]}
                    <br/> <span style={{marginLeft: '23px'}}>{{ en: '', zh: '', th: `${selectedTicketType.deliveryPrice > 0 ? '(มีค่าจัดส่งเพิ่มเติม/ชิ้น)' : ''}` }[locale]}</span>
                  </Radio>
                  { deliveryOption === 'optional' && <Radio value={false}>{{ en: 'Collect by yourself', zh: 'Collect by yourself', th: 'รับด้วยตนเองในวันงาน' }[locale]}</Radio>}
                </Radio.Group>
              )}
              {/* deliveryDecorator(<Checkbox disabled={deliveryRequired} ><Tag color="blue">{selectedTicketType.deliveryPrice} THB</Tag></Checkbox>) */}
            </Form.Item>
              }
              {(deliverySelected || regFields['address']) &&
          <React.Fragment>
            <Form.Item key="recipient" label={{ en: 'Recipient', zh: 'Recipient', th: 'ชื่อผู้รับ' }[locale]} {...inputCols}>
              {getFieldDecorator(`tickets[${groupIndex}].deliverTo.recipient`, {
                rules: [{ required: true }],
                initialValue: _get(
                  participant,
                  `tickets[${groupIndex}].deliverTo.recipient`
                )
              })(
                <Input />
              )}
            </Form.Item>
            <Form.Item key="street" label={{ en: 'Address', zh: 'Address', th: 'ที่อยู่' }[locale]} {...inputCols}>
              {getFieldDecorator(`tickets[${groupIndex}].deliverTo.street`, {
                rules: [{ required: true }],
                initialValue: _get(
                  participant,
                  `tickets[${groupIndex}].deliverTo.street`
                )
              })(
                <Input />
              )}
            </Form.Item>
            <Form.Item key="locality" label={{ en: 'Locality', zh: 'Locality', th: 'ตำบล/แขวง' }[locale]} {...inputCols}>
              {getFieldDecorator(`tickets[${groupIndex}].deliverTo.locality`, {
                rules: [{ required: true }],
                initialValue: _get(
                  participant,
                  `tickets[${groupIndex}].deliverTo.locality`
                )
              })(
                <Input />
              )}
            </Form.Item>
            <Form.Item key="city" label={{ en: 'City', zh: 'City', th: 'อำเภอ/เขต' }[locale]} {...inputCols}>
              {getFieldDecorator(`tickets[${groupIndex}].deliverTo.city`, {
                rules: [{ required: true }],
                initialValue: _get(
                  participant,
                  `tickets[${groupIndex}].deliverTo.city`
                )
              })(
                <Input />
              )}
            </Form.Item>
            <Query query={statesQuery} variables={{ countryName: 'Thailand' }}>
              {({ data, loading }) => {
                if (loading) return <div>Loading...</div>
                if (!data) return <div>Data not found</div>
                return <Form.Item
                  label={{ en: 'State/Province', zh: 'State/Province', th: 'จังหวัด' }[locale]}
                  {...inputCols}
                >
                  {getFieldDecorator(`tickets[${groupIndex}].deliverTo.region`, {
                    rules: [{ required: true }],
                    initialValue: _get(
                      participant,
                      `tickets[${groupIndex}].deliverTo.region`
                    )
                  })(
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .startsWith(input.toLowerCase())}
                    >
                      {data.statesByCountry.map(state =>
                        <Select.Option
                          key={state._id}
                          value={state._id}
                        >
                          {localeGet(state, 'name', locale)}
                        </Select.Option>
                      )}
                    </Select>
                  )}
                </Form.Item>
              }}
            </Query>
            <Form.Item key="postalCode" label={{ en: 'Postal Code', zh: 'Postal Code', th: 'รหัสไปรษณีย์' }[locale]} {...inputCols}>
              {getFieldDecorator(`tickets[${groupIndex}].deliverTo.postalCode`, {
                rules: [{ required: true }],
                initialValue: _get(
                  participant,
                  `tickets[${groupIndex}].deliverTo.postalCode`
                )
              })(
                <Input />
              )}
            </Form.Item>
          </React.Fragment>}
              {$ticketQuestions}
              <Form.Item
                label="Reserved Number"
                // {...inputCols}
                // {...formItemLayout}
              >
                {getFieldDecorator(`tickets[${groupIndex}].reservedNumber`, {
                  initialValue: _get(ticket, 'reservedNumber')
                })(
                  <Input key="reservedNumber"/>
                )}
              </Form.Item>
              <Form.Item
                label="BIB Number"
                // {...inputCols}
                // {...formItemLayout}
              >
                {getFieldDecorator(`tickets[${groupIndex}].number`, {
                  initialValue: _get(ticket, 'number')
                })(
                  <Input key="ticketNumber"/>
                )}
              </Form.Item>
              {couponCodeEnabled && <Form.Item label={{ en: 'Code', zh: 'Code', th: 'Code' }[locale]} {...inputCols} extra={couponCodeInfo}>
                <Row gutter={8}>
                  <Col span={18}>
                    {getFieldDecorator(
                      `tickets[${groupIndex}].couponCodeText`,
                      {
                        validateTrigger: [],
                        rules: [
                          {
                            validator: this.couponCodeValidator
                          }
                        ],
                        onChange: () =>
                          this.handleCouponCodeTextChange({
                            groupIndex
                          })
                      }
                    )(<Input />)}
                  </Col>
                  <Col span={6}>
                    <Button disabled={!couponCodeText} onClick={e => this.checkCouponCode(
                      { groupIndex }
                    )}>
                      Check
                    </Button>
                  </Col>
                </Row>
              </Form.Item>}
            </div>}
          </Input.Group>
        }
        return <div
          style={{background: _get(ticketGroup, 'backgroundColor')}}
          key={`ticketGroupWrapper[${groupIndex}]`}
          className={groupId === 'null' ? '' : 'ticketGroupWrapper'}>
          {ticketGroup$}
          {afterTicketGroup$}
        </div>
      })

      // TODO: filter by period
      // const firstName = _get(participant, 'profile.firstName')
      // const lastName = _get(participant, 'profile.lastName')
      // participantFields = participantFields.concat([
      //   `profile.firstName`,
      //   `profile.lastName`,
      //   `profile.gender`,
      //   `profile.birthDate`,
      //   `profile.email`
      // ])
      // const taxInvoiceType = getFieldValue(`profile.taxInvoice.type`)
      // const receiptType = getFieldValue(`profile.receipt.type`)
      const birthDate = getFieldValue(`profile.birthDate`)
      const gender = getFieldValue(`profile.gender`)
      const nationality = getFieldValue(`profile.nationality`)

      return (<Layout>
        <Layout.Content className="content form-content participantForm">
          <Form>
            <Input.Group key={`profile`}>
            {console.log(participant,'s')}
            {regFields['prefix'] &&
                  <Form.Item label={'คำนำหน้าชื่อ'} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.prefix`, {
                      initialValue: _get(participant, 'profile.prefix'),
                      rules: [{ required: _get(regFields, 'prefix.required'),
                        message: 'This field is required' }]
                    })(
                      <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .startsWith(input.toLowerCase())}
                      >
                      <MenuItem
                        value='mr'
                      >
                        นาย
                      </MenuItem>
                      <MenuItem
                        value='mrs'
                      >
                        นาง
                      </MenuItem>
                      <MenuItem
                        value='miss'
                      >
                        นางสาว
                      </MenuItem>
                      <MenuItem
                        value='mstr'
                      >
                        เด็กชาย
                      </MenuItem>
                      <MenuItem
                        value='ms'
                      >
                        เด็กหญิง
                      </MenuItem>
                    </Select>
                    )}
                  </Form.Item>
              }
              <Form.Item label={`${t('participant.firstname')}`} {...inputCols} {...formItemLayout}>
                {getFieldDecorator(`profile.firstName`, {
                  initialValue: _get(participant, 'profile.firstName'),
                  rules: getRules(regFields['firstName'])
                })(<Input key={`firstName`} />)}
              </Form.Item>
              <Form.Item label={`${t('participant.lastname')}`} {...inputCols} {...formItemLayout}>
                {getFieldDecorator(`profile.lastName`, {
                  initialValue: _get(participant, 'profile.lastName'),
                  rules: getRules(regFields['lastName'])
                })(<Input key={`lastName`} />)}
              </Form.Item>
              {regFields['imageUrl'] &&
              <Form.Item
                label="Front face picture"
                {...inputCols}
                {...formItemLayout}
                extra={_get(participant, 'profile.imageValidation.errors', []).map(error =>
                  <div key={error} style={{ color: 'orange' }}>{error}</div>
                  // intl.formatMessage({ id: `api.faceValidate.${error}` })
                )}
              >
                {getFieldDecorator(`profile.imageUrl`, {
                  initialValue: _get(participant, 'profile.imageUrl')
                  // onChange: this.handleProfileImageChange
                })(<CloudUploader provider="s3" object="faces" maxDimension={720} />)}
              </Form.Item>
              }
              {regFields['gender'] && <Form.Item label={`${t('participant.gender')}`} {...inputCols} {...formItemLayout}>
                {getFieldDecorator(`profile.gender`, {
                  initialValue: _get(participant, 'profile.gender'),
                  rules: [{ required: true, message: 'กรุณาเลือกเพศ' }]
                })(
                  <Radio.Group key={`gender`}>
                    <Radio.Button key="male" value="male">
                      <Icon type="man" /> {`${t('participant.male')}`}
                    </Radio.Button>
                    <Radio.Button key="female" value="female">
                      <Icon type="woman" /> {`${t('participant.female')}`}
                    </Radio.Button>
                    <Radio.Button key="lgbtq" value="lgbtq">
                      <FontAwesomeIcon icon={faVenusMars} /> LGBTQ+
                    </Radio.Button>
                  </Radio.Group>
                )}
              </Form.Item>}
              {/* <Form.Item label={'Birth Date'} {...inputCols}>
                  {getFieldDecorator(`profile.birthDate`, {
                    initialValue: birthDate,
                    rules: [{ required: true, message: 'Please input birth date' }]
                  })(<DatePicker key={`birthDate`} />)}
                </Form.Item> */}
              {regFields['birthDate'] && <Form.Item
                // labelCol={{ span: 4 }}
                // wrapperCol={{ span: 20 }}
                {...formItemLayout}
                label={`${t('participant.birthday')}`}
              >
                <Row gutter={8}>
                  <Col span={12}>
                    <Form.Item hasFeedback>
                      {getFieldDecorator(
                        `profile.birthDate`,
                        {
                          initialValue: moment(_get(participant, 'profile.birthDate')),
                          rules: [
                            {
                              required: true,
                              message: 'กรุณากรอกวันเกิด!'
                            }
                          ]
                        }
                      )(
                        <DatePicker format={dateFormat}/>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>}
              {isLineLogin ? getFieldDecorator(`profile.email`,
              { initialValue: _get(participant, 'profile.email') }) : <Form.Item label={'Email'} {...inputCols} {...formItemLayout}>
                {getFieldDecorator(`profile.email`, {
                  initialValue: _get(participant, 'profile.email'),
                  rules: [
                    {
                      type: 'email',
                      message: 'คุณกรอก E-mail ไม่ถูกต้อง!'
                    },
                    { required: true, message: 'กรุณากรอก E-mail' }
                  ]
                })(<Input key={`email`} />)}
              </Form.Item>}
              <Form.Item label={`${t('participant.phone')}`} {...inputCols} {...formItemLayout}>
                {getFieldDecorator(`profile.telephone`, {
                  initialValue: _get(participant, 'profile.telephone'),
                  rules: [{ required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' }]
                })(<Input key={`telephone`} />)}
              </Form.Item>
              {console.log(participant)}
              {regFields['weight'] &&
                  <Form.Item label={'น้ำหนัก (กิโลกรัม)'} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.weight`, {
                      initialValue: _get(participant, 'profile.weight'),
                      rules: [{ required: _get(regFields, 'weight.required'),
                        message: 'This field is required' }]
                    })(<Input type="number" key={`weight`} />)}
                  </Form.Item>
              }
              {regFields['height'] &&
                  <Form.Item label={'ส่วนสูง (เซนติเมตร)'} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.height`, {
                      initialValue: _get(participant, 'profile.height'),
                      rules: [{ required: _get(regFields, 'height.required'),
                        message: 'This field is required' }]
                    })(<Input type="number" key={`height`} />)}
                  </Form.Item>
              }
              {regFields['club'] &&
                  <Form.Item label={'Club'} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.club`, {
                      initialValue: _get(participant, 'profile.club'),
                      rules: [{ required: _get(regFields, 'club.required'),
                        message: 'This field is required' }]
                    })(<Input key={`club`} />)}
                  </Form.Item>
              }
              {regFields['healthIssues'] &&
                  <Form.Item label={'Health Issues'} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.healthIssues`, {
                      initialValue: _get(participant, 'profile.healthIssues'),
                      rules: [{ required: _get(regFields, 'healthIssues.required'),
                        message: 'This field is required' }]
                    })(<Input key={`healthIssues`} />)}
                  </Form.Item>
              }
              {regFields['bloodType'] &&
                  <Form.Item label={'Blood Type'} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.bloodType`, {
                      initialValue: _get(participant, 'profile.bloodType'),
                      rules: [{ required: _get(regFields, 'healthIssues.required'),
                        message: 'This field is required' }]
                    })(<Input key={`bloodType`} />)}
                  </Form.Item>
              }
              {regFields['allergies'] &&
                  <Form.Item label={'Allergies'} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.allergies`, {
                      initialValue: _get(participant, 'profile.allergies'),
                      rules: [{ required: _get(regFields, 'allergies.required'),
                        message: 'This field is required' }]
                    })(<Input key={`allergies`} />)}
                  </Form.Item>
              }
              {regFields['emergencyContact'] &&
                  [<Form.Item label={`${t('participant.emergency')}`} {...inputCols} key="profile.emergencyContact.name" {...formItemLayout}>
                    {getFieldDecorator(`profile.emergencyContact.name`, {
                      initialValue: _get(participant, 'profile.emergencyContact.name'),
                      rules: [{ required: _get(regFields, 'emergencyContact.required'),
                        message: 'This field is required' }]
                    })(<Input key={`emergencyContactName`} />)}
                  </Form.Item>,
                  <Form.Item label={`${t('participant.relation')}`} {...inputCols} key="profile.emergencyContact.relationship" {...formItemLayout}>
                    {getFieldDecorator(`profile.emergencyContact.relationship`, {
                      initialValue: _get(participant, 'profile.emergencyContact.relationship'),
                      rules: [{ required: ["65c303c453708b2a528b219a", "6789a0c172e315191ea90264"].includes(`${_get(participant, 'eventId')}`) ? false : _get(regFields, 'emergencyContact.required'),
                        message: 'This field is required' }]
                    })(<Input key={`emergencyContactRelationship`} />)}
                  </Form.Item>,
                  <Form.Item label={`${t('participant.emergencyPhone')}`} {...inputCols} key="profile.emergencyContact.phone" {...formItemLayout}>
                    {getFieldDecorator(`profile.emergencyContact.phone`, {
                      initialValue: _get(participant, 'profile.emergencyContact.phone'),
                      rules: [{ required: _get(regFields, 'emergencyContact.required'),
                        message: 'This field is required' }]
                    })(<Input key={`emergencyContactPhone`} />)}
                  </Form.Item>]
              }
              {regFields['nationalId'] &&
                  <Form.Item label={`${t('participant.idCard')}`} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.nationalId`, {
                      initialValue: _get(participant, 'profile.nationalId'),
                      rules: [{ required: _get(regFields, 'nationalId.required'),
                        message: 'This field is required' }]
                    })(<Input key={`nationalId`} />)}
                  </Form.Item>
              }
              {regFields['nationality'] &&
                  <Form.Item label={`${t('participant.nationality')}`} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.nationality`, {
                      initialValue: _get(participant, 'profile.nationality'),
                      rules: [{ required: _get(regFields, 'nationality.required'),
                        message: 'This field is required' }]
                    })(
                      <Select
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .startsWith(input.toLowerCase())}
                      >
                        {nationalities.map(nationality =>
                          <Select.Option key={nationality} value={nationality}>
                            {nationality}
                          </Select.Option>
                        )}
                      </Select>
                    )}
                  </Form.Item>
              }
              {regFields['street'] &&
              <Form.Item
                label={`${t('participant.address')}`}
                {...inputCols} {...formItemLayout}
              >
                {getFieldDecorator(`profile.street`, {
                  initialValue: _get(participant, 'profile.street'),
                  rules: [{ required: _get(regFields, 'street.required'),
                    message: requiredFieldMessage }]
                })(
                  <Input />
                )}
              </Form.Item>
              }
              {regFields['locality'] &&
              <Form.Item
                label='ตำบล/แขวง'
                {...inputCols} {...formItemLayout}
              >
                {getFieldDecorator(`profile.locality`, {
                  initialValue: _get(participant, 'profile.locality'),
                  rules: [{ required: _get(regFields, 'locality.required'),
                    message: requiredFieldMessage }]
                })(
                  <Input />
                )}
              </Form.Item>
              }
              {regFields['city'] &&
              <Form.Item
                label={`${t('participant.city')}`}
                {...inputCols} {...formItemLayout}
              >
                {getFieldDecorator(`profile.city`, {
                  initialValue: _get(participant, 'profile.city'),
                  rules: [{ required: _get(regFields, 'city.required'),
                    message: requiredFieldMessage }]
                })(
                  <Input />
                )}
              </Form.Item>}
              {regFields['province'] &&
                  <Form.Item label={`${t("eventFromEdit.participantEdit.province")}`} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.province`, {
                      initialValue: _get(participant, 'profile.province'),
                      rules: [{ required: _get(regFields, 'province.required'),
                        message: 'This field is required' }]
                    })(
                      <Select
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0}
                      >
                        {provinces.map(province =>
                          <Select.Option
                            key={province.name.en}
                            value={province.name.en}
                          >
                            {province.name.en}
                          </Select.Option>
                        )}
                      </Select>
                    )}
                  </Form.Item>
              }
              {regFields['postalCode'] &&
                  <Form.Item label={`${t("eventFromEdit.participantEdit.postalCode")}`} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.postalCode`, {
                      initialValue: _get(participant, 'profile.postalCode'),
                      rules: [{ required: _get(regFields, 'postalCode.required'),
                        message: 'This field is required' }]
                    })(<Input key={`postalCode`} />)}
                  </Form.Item>
              }
              {regFields['country'] &&
                  <Form.Item label={`${t("eventFromEdit.participantEdit.country")}`} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.country`, {
                      initialValue: _get(participant, 'profile.country'),
                      rules: [{ required: _get(regFields, 'country.required'),
                        message: 'This field is required' }]
                    })(
                      <Select
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .startsWith(input.toLowerCase())}
                      >
                        {countries.map(country =>
                          <Select.Option
                            key={country}
                            value={country}
                          >
                            {country}
                          </Select.Option>
                        )}
                      </Select>
                    )}
                  </Form.Item>
              }
              {regFields['taxInvoice'] &&
                  [<Form.Item label={'ประเภทใบกำกับภาษี'} {...inputCols} key="taxInvoiceType" {...formItemLayout}>
                    {getFieldDecorator(`profile.taxInvoice.type`, {
                      initialValue: _get(participant, 'profile.taxInvoice.type'),
                      rules: [{ required: _get(regFields, 'taxInvoiceType.required'),
                        message: 'This field is required' }]
                    })(
                      <Select key={`taxInvoiceType`} >
                        <Option value="none">None</Option>
                        <Option value="individual">Individual</Option>
                        <Option value="company">Company</Option>
                      </Select>
                    )}
                  </Form.Item>,
                  <Form.Item label={'หมายเลขประจำตัวผู้เสียภาษี'} {...inputCols} key="taxInvoiceTaxId" {...formItemLayout}>
                    {getFieldDecorator(`profile.taxInvoice.taxId`, {
                      initialValue: _get(participant, 'profile.taxInvoice.taxId'),
                      rules: [{ required: _get(regFields, 'taxInvoiceTaxId.required'),
                        message: 'This field is required' }]
                    })(<Input key={`taxInvoiceTaxId`} />)}
                  </Form.Item>,
                  <Form.Item label={'ชื่อผู้เสียภาษี'} {...inputCols} key="taxInvoiceTaxId" {...formItemLayout}>
                    {getFieldDecorator(`profile.taxInvoice.name`, {
                      initialValue: _get(participant, 'profile.taxInvoice.name'),
                      rules: [{ required: _get(regFields, 'taxInvoiceTaxId.required'),
                        message: 'This field is required' }]
                    })(<Input key={`taxInvoiceName`} />)}
                  </Form.Item>,
                  <Form.Item label={'ที่อยู่ใบกำกับภาษี'} {...inputCols} key="taxInvoiceAddress" {...formItemLayout}>
                    {getFieldDecorator(`profile.taxInvoice.address`, {
                      initialValue: _get(participant, 'profile.taxInvoice.address'),
                      rules: [{ required: _get(regFields, 'taxInvoiceAddress.required'),
                        message: 'This field is required' }]
                    })(<Input key={`taxInvoiceAddress`} />)}
                  </Form.Item>]
              }
              {regFields['receipt'] &&
                  [<Form.Item label={'ประเภทใบเสร็จรับเงิน'} {...inputCols} key="receiptType" {...formItemLayout}>
                    {getFieldDecorator(`profile.receipt.type`, {
                      initialValue: _get(participant, 'profile.receipt.type'),
                      rules: [{ required: _get(regFields, 'receiptType.required'),
                        message: 'This field is required' }]
                    })(
                      <Select key={`receiptType`} >
                        <Option value="none">None</Option>
                        <Option value="individual">Individual</Option>
                        <Option value="company">Company</Option>
                      </Select>
                    )}
                  </Form.Item>,
                  <Form.Item label={'หมายเลขประจำตัวผู้เสียภาษี'} {...inputCols} key="receiptTaxId" {...formItemLayout}>
                    {getFieldDecorator(`profile.receipt.taxId`, {
                      initialValue: _get(participant, 'profile.receipt.taxId'),
                      rules: [{ required: _get(regFields, 'receiptTaxId.required'),
                        message: 'This field is required' }]
                    })(<Input key={`receiptTaxId`} />)}
                  </Form.Item>,
                  <Form.Item label={'ชื่อผู้เสียภาษี'} {...inputCols} key="receiptTaxId" {...formItemLayout}>
                    {getFieldDecorator(`profile.receipt.name`, {
                      initialValue: _get(participant, 'profile.receipt.name'),
                      rules: [{ required: _get(regFields, 'receiptTaxId.required'),
                        message: 'This field is required' }]
                    })(<Input key={`receiptName`} />)}
                  </Form.Item>,
                  <Form.Item label={'ที่อยู่ใบกำกับภาษี'} {...inputCols} key="receiptAddress" {...formItemLayout}>
                    {getFieldDecorator(`profile.receipt.address`, {
                      initialValue: _get(participant, 'profile.receipt.address'),
                      rules: [{ required: _get(regFields, 'receiptAddress.required'),
                        message: 'This field is required' }]
                    })(<Input key={`receiptAddress`} />)}
                  </Form.Item>]
              }
              {regFields['address'] &&
                  [<Form.Item label={'ภูมิภาค'} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.address.region`, {
                      initialValue: _get(participant, 'profile.address.region'),
                      rules: [{ required: _get(regFields, 'addressRegion.required'),
                        message: 'This field is required' }]
                    })(<Input key={`addressRegion`} />)}
                  </Form.Item>,
                  <Form.Item label={'ตำบล'} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.address.locality`, {
                      initialValue: _get(participant, 'profile.address.locality'),
                      rules: [{ required: _get(regFields, 'addressLocality.required'),
                        message: 'This field is required' }]
                    })(<Input key={`addressLocality`} />)}
                  </Form.Item>,
                  <Form.Item label={'ประเทศ'} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.address.country`, {
                      initialValue: _get(participant, 'profile.address.country'),
                      rules: [{ required: _get(regFields, 'addressCountry.required'),
                        message: 'This field is required' }]
                    })(<Input key={`addressCountry`} />)}
                  </Form.Item>,
                  <Form.Item label={'รหัสไปรษณีย์'} {...inputCols} {...formItemLayout}>
                    {getFieldDecorator(`profile.address.postalCode`, {
                      initialValue: _get(participant, 'profile.address.postalcode'),
                      rules: [{ required: _get(regFields, 'addressPostalCode.required'),
                        message: 'This field is required' }]
                    })(<Input key={`addressPostalCode`} />)}
                  </Form.Item>]
              }

            </Input.Group>
            <Form.Item label={'*'} {...inputCols} {...formItemLayout}>
              {_get(ticketGroupIds, [0]) !== 'null' &&
                [<Form.Item
                  key="ticketGroups"
                  className="ticketGroupForm"
                  label={{ en: 'Choose series', zh: 'Choose series', th: 'เลือกสนาม' }[locale]}
                  extra={
                    ticketGroupIds.length > 0
                      ? { en: 'Enble to choose more then 1', zh: 'Enble to choose more then 1', th: 'เลือกได้มากกว่า 1 สนาม' }[locale]
                      : ''
                  }
                  {...inputCols}
                >
                  {this.state.ticketGroupValidation &&
                    <span style={{color: 'red'}}>{requiredFieldMessage}</span>
                  }
                </Form.Item>]}
              {$ticketGroups}
              {regFields['consent'] && <Form.Item label={{ en: 'Applicant agrees to the following conditions', zh: 'Applicant agrees to the following conditions', th: 'ผู้สมัครยินยอมตามเงื่อนไขดังต่อไปนี้' }[locale]} {...inputCols}
                extra={localeGet(regFields, 'consent.extraMessage', `${config.default_locale}`)}>
                {getFieldDecorator(`profile.consent`, {
                  initialValue: _get(initProfile, 'consent') || 'agree',
                  rules: getRules(regFields['consent'])
                })(<Radio.Group key={`consent`} buttonStyle="solid">
                  <Radio key="agree" value="agree">
                    {{ en: 'agree', zh: 'agree', th: 'ยินยอม' }[locale]}
                  </Radio>
                  <Radio key="disagree" value="disagree" >
                    {{ en: 'disagree', zh: 'disagree', th: 'ไม่ยินยอม' }[locale]}
                  </Radio>
                </Radio.Group>)}
              </Form.Item>}
            </Form.Item>
            <Form.Item label={`${t('participant.note')}`} {...inputCols} {...formItemLayout}>
              {getFieldDecorator(`remarks`, {
                initialValue: _get(participant, 'remarks')
              })(<Input.TextArea key={`remarks`} />)}
            </Form.Item>
            <Form.Item {...tailFormItemLayout} >
              <Button
                type="primary"
                htmlType="submit"
                onClick={handleSubmit}
                // style={{ float: 'right' }}
                className="btn"
                icon="save"
                loading={this.submitting}
              >
                    {`${t('utils.save')}`}
              </Button>
              <Button loading={this.submitting} className="btn" type="ghost" onClick={() => {
                this.props.history.goBack()
              }} >{`${t('utils.cancel')}`}</Button>
            </Form.Item>
          </Form>
        </Layout.Content>
      </Layout>
      )
    }
  }
}

export default compose(
  Form.create(),
  graphql(updateParticipantMutation, {
    name: 'updateParticipant'
  }),
  graphql(participantQuery, {
    options: ({ match: { params: { eventId, id } } }) => ({
      variables: { eventId, id },
      fetchPolicy: "network-only"
    })
  }),
  graphql(adminQuery, {
    options: (props) => ({
      variables: {
        _id: clientAuth.login()._id
      }
    }),
    props: ({ data: { loading, adminUser } }) => ({
      adminLoading: loading,
      admin: adminUser
    })
  }),
  withTranslation()
)(Ticket)
